import React from 'react';
import _ from 'underscore';

import {ActionOrigin} from 'constants/AnalyticsConstants';
import DataCatalogItemDetails from 'data-catalog/DataCatalogItemDetails';
import DataCatalogOrigin from 'data-catalog/DataCatalogOrigin';
import {updateDataset} from 'data-frames/network/DatasetDAO';
import {DataFrameTableMode} from 'data-frames/table/DataFrameTableConstants';
import {DatasetViewQuery} from 'data-frames/workspace/__generated/DatasetViewQuery';
import {QueriedPersistedDataFrameTableWrapper} from 'data-frames/wrapper/PersistedDataFrameTableWrapper';
import ExtractByTypename from 'graphql-client/ExtractByTypename';
import {isInaccessible} from 'graphql-client/InaccessibleInfo';
import {formatBytes} from 'util/NameUtil';

type Dataset = ExtractByTypename<DatasetViewQuery['dataset'], 'DatasetNode'>;

interface DatasetDetailsProps {
  dataset: Dataset;
  reload: () => void;
}

export default function DatasetDetails({dataset, reload}: DatasetDetailsProps): JSX.Element {
  const clientStateId = _.uniqueId('dataset-details-');
  const dataFrame = isInaccessible(dataset.dataFrame) ? null : dataset.dataFrame;
  const hasContent = dataFrame != null;

  const extraColumns = [
    {
      label: 'Origin',
      value: <DataCatalogOrigin originType={dataset.originType} lineageParent={dataset.lineageParent} />,
    },
    {label: 'Size', value: dataFrame?.size ? formatBytes(dataFrame.size) : ''},
    {label: 'Benchling Dataset ID', value: dataset.displayId},
  ];
  const actionOrigin = ActionOrigin.DATASET_PAGE;

  return (
    <DataCatalogItemDetails
      dataCatalogItem={dataset}
      extraColumns={extraColumns}
      metadataTitle="Dataset Metadata"
      tagsEmptyMessage="This dataset has no custom fields."
      hasContent={hasContent}
      preferenceKey="dataset"
      onChange={async (updateParams: {
        id: string;
        name?: string;
        folderId?: string;
        customFields?: {[name: string]: string};
      }): Promise<void> => {
        await updateDataset(updateParams);
        reload();
      }}
    >
      <div style={{marginTop: 12}}>
        {dataFrame && (
          <QueriedPersistedDataFrameTableWrapper
            persistedDataFrame={dataFrame}
            actionOrigin={actionOrigin}
            clientStateId={clientStateId}
            defaultTableMode={DataFrameTableMode.RICH}
            renderIsExcludedColumn={false}
          />
        )}
      </div>
    </DataCatalogItemDetails>
  );
}
